import { render, staticRenderFns } from "./OtherOfficeFacilityDetail.vue?vue&type=template&id=34e231b1&scoped=true&lang=pug"
import script from "./OtherOfficeFacilityDetail.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeFacilityDetail.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeFacilityDetail.vue?vue&type=style&index=0&id=34e231b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e231b1",
  null
  
)

export default component.exports